import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  word-break: break-word;
  white-space: pre-wrap;
`;
